import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import user from './modules/user';
import order from './modules/order';
import ticket from './modules/ticket';
import city from './modules/city';
import skuData from './modules/skudata';
import reward from './modules/reward';
import type { AppState } from './types';

Vue.use(Vuex);

const plugins = process.env.NODE_ENV !== 'production' ? [
  // createPersistedState({
  //   storage: window.sessionStorage,
  //   // 配置白名单
  //   paths: [],
  // }),
  createLogger({}),
] : [];


const gStore = new Vuex.Store<AppState>({
  modules: {
    user,
    order,
    ticket,
    city,
    skuData,
    reward,
  },
  strict: process.env.NODE_ENV !== 'production',
  plugins,
  actions: {},
  getters: {},
  mutations: {},
});

export default gStore;

// class StoreSpeedy {
//   private store: Store<any> = gStore
//   get state(): AppState {
//     return this.store.state;
//   }
// }

// // 方便全局使用的store
// export const storeSpeedy = new StoreSpeedy();
